import React from 'react';
import { Tag } from 'components/Tag';
import { useTranslation } from 'react-i18next';
import { TagColorWithIntensity } from 'styles/userConstants';
import { UserAccount, UserPlan } from 'types/user';
import { BadgeColor } from 'types/colors';

interface Props {
  userAccount: UserAccount;
}

export function TagPlan({ userAccount }: Props) {
  const { currentPlan, isOnOldPricing, currentPlanLabel } = userAccount;
  const { t } = useTranslation(['common']);

  const planColors: Record<
    UserPlan | 'old',
    { color: TagColorWithIntensity | BadgeColor; label: string }
  > = {
    trial: { color: 'gris-quiet', label: currentPlanLabel },
    free: { color: 'gris-quiet', label: currentPlanLabel },
    essentiel: {
      color: 'violine-supershy',
      label: currentPlanLabel,
    },
    integral: {
      color: 'aloe-vera-supershy',
      label: currentPlanLabel,
    },
    avance: {
      color: 'gris-quiet',
      label: currentPlanLabel,
    },
    old: { color: 'yellow', label: t('common:oldOffer') },
  };

  const planKey = isOnOldPricing ? 'old' : currentPlan;
  const { color, label } = planColors[planKey] || planColors.trial;

  return <Tag color={color}>{label}</Tag>;
}
